export default __webpack_public_path__ + "static/media/bci-1-hover.d34c04e2.svg";